// ---------------------------------------------------------------------------
// Shared between exportCsvProject.ts (writer) and importCsvProject.ts
// (reader): the APO_ARCHIVOS_SIMULACION labels and default file names for
// the 5 structural files EvalHid_cal itself reads (everything except the
// per-model Ent_{modelo}_Param.csv files, whose names are never read from
// that table — see exportCsvProject.ts's own note). Defaults confirmed by
// reading a real project's APO_ARCHIVOS_SIMULACION with mdb-reader (see
// test/fixtures/ModeloTuria/EvalhidTuria2026.ehd) — not hardcoded anywhere
// in the original VB source.
// ---------------------------------------------------------------------------

export const LABEL_SUBBASINS = "ARCHIVO_DATOS_CUENCAS";
export const LABEL_OUTLET_POINTS = "ARCHIVO_APORTACION";
export const LABEL_AQUIFERS = "ARCHIVO_ACUIFEROS";
export const LABEL_CONFIG = "ARCHIVO_CONFIGURACION";
// Sic: real typo in the original DB, see project.ts's own note on the same table.
export const LABEL_LABELS = "ARVHIVO_ETIQUETAS";

export const DEFAULT_PATHS: Record<string, string> = {
  [LABEL_SUBBASINS]: "Ent_Cuencas.csv",
  [LABEL_OUTLET_POINTS]: "Ent_Apo.csv",
  [LABEL_AQUIFERS]: "Ent_Acu.csv",
  [LABEL_CONFIG]: "Ent_Config.csv",
  [LABEL_LABELS]: "Ent_Etiquetas.csv",
};

/** Same defaults project.ts's own openProject() reads from APO_ARCHIVOS_SIMULACION — hardcoded here too since a CSV-only folder (no .ehd) has no such table to read a custom path from. */
export const DEFAULT_SERIES_PATHS = {
  precipitation: "Ent_Precip.csv",
  etp: "Ent_Etp.csv",
  temperature: "Ent_Tempe.csv",
  pumping: "Ent_Bomb.csv",
};

/**
 * `Ent_{modelo}_Param.csv` — the one file name NOT read from
 * APO_ARCHIVOS_SIMULACION in the original, built directly from the model's
 * own name (Form1.vb:2081) — the only accented character it strips is "é"
 * (Témez → Temez), nothing else. Used by exportCsvProject.ts (writer) and
 * importCsvProject.ts/updateProjectFromCsv.ts (readers) to agree on the same
 * name — moved here from exportCsvProject.ts (deep-review, 2026-08-29) so
 * the readers depend on this shared naming module directly instead of on
 * the writer.
 */
export function paramFileName(modelTypeName: string): string {
  return `Ent_${modelTypeName.replace(/é/g, "e")}_Param.csv`;
}
